import http from "../http-common";

class ParticipantService {
  create_participants(data) {
    return http.post(`/participants`, data);
  }
  get_participants() {
    return http.get(`/participants`);
  }
  get_participant(id) {
    return http.get('/participants/' + id);
  }
  
  getById(id) {
    return http.get('/participants/getById/' + id);
  }
  get_participant_by_monitoring(id) {
    return http.get('/participants/findOneByMonitoringNumberId/' + id);
  }
  get_participant_by_imei(id) {
    return http.get('/participants/findOneByIMEI/' + id);
  }
  updateparticipants(id, data) {
    return http.put(`/participants/${id}`, data);
  }
  deleteteacher(id) {
    return http.delete('/participants/' + id);
  }
}

export default new ParticipantService();